import React from 'react';

const DashboardPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container-width section-padding py-20">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Dashboard</h1>
          <p className="text-xl text-gray-600">Coming soon - User dashboard</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
